"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.dynamicRequire = void 0;
const dynamicRequire = (name) => require(name);
exports.dynamicRequire = dynamicRequire;
//# sourceMappingURL=dynamicRequire.js.map